import React, { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logoImage from '../../assets/logo-top-left.svg';

const GREEN = '#6fc86f';

const FooterNew: FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const go = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <footer
      className="bg-white border-t"
      style={{ borderColor: '#e3f1dd', fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-0">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* ── Brand column ─────────────────────────────── */}
          <div className="lg:col-span-1 space-y-4">
            <img
              src={logoImage}
              alt="Dhoondh"
              className="h-9 w-auto object-contain"
              onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
            />

            <p className="italic text-sm leading-relaxed" style={{ color: '#4c4c4c' }}>
              "तुरंत पोस्ट करो और पाओ परफेक्ट मैच!<br />ढूंढ के तो देखो..."
            </p>

            {/* Contact */}
            <div className="space-y-2">
              <a
                href="mailto:operations@dhoondh.in"
                className="flex items-center gap-2 text-sm transition-colors"
                style={{ color: '#4c4c4c' }}
              >
                <svg className="w-5 h-5 shrink-0" style={{ color: GREEN }} fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                operations@dhoondh.in
              </a>
              <a
                href="tel:+919316846322"
                className="flex items-center gap-2 text-sm transition-colors"
                style={{ color: '#4c4c4c' }}
              >
                <svg className="w-5 h-5 shrink-0" style={{ color: GREEN }} fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                +91 93168 46322
              </a>
            </div>

            {/* Social icons */}
            <div className="flex gap-3 pt-1">
              <a
                href="https://wa.me/919316846322"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                style={{ backgroundColor: '#f3f4f6' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = GREEN)}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
              >
                <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.52 3.48A11.94 11.94 0 0012.06.03C5.64.03.45 5.22.45 11.64c0 2.05.54 4.05 1.57 5.82L.02 24l6.69-2.02a11.7 11.7 0 005.35 1.34h.01c6.43 0 11.62-5.19 11.62-11.61 0-3.1-1.21-6.02-3.17-8.23z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/dhoondh-ltd/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                style={{ backgroundColor: '#f3f4f6' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = GREEN)}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
              >
                <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/dhoondh.in"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                style={{ backgroundColor: '#f3f4f6' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = GREEN)}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
              >
                <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </div>
          </div>

          {/* ── For Candidates ───────────────────────────── */}
          <div>
            <h4 className="font-semibold text-black mb-5" style={{ fontSize: '18px' }}>
              For Candidates
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Create Profile',       path: '/register' },
                { label: 'Resume Builder',        path: '/services' },
                { label: 'Browse Jobs',           path: '/services' },
                { label: 'Contact Us',            path: '/contact' },
              ].map(({ label, path }) => (
                <li key={label}>
                  <button
                    onClick={go(path)}
                    className="text-sm transition-colors text-left"
                    style={{ color: '#4c4c4c' }}
                    onMouseEnter={e => (e.currentTarget.style.color = GREEN)}
                    onMouseLeave={e => (e.currentTarget.style.color = '#4c4c4c')}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ── For Companies ────────────────────────────── */}
          <div>
            <h4 className="font-semibold text-black mb-5" style={{ fontSize: '18px' }}>
              For Companies
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Register Company', path: '/register' },
                { label: 'Post a Job',        path: '/register' },
                { label: 'Contact Sales',     path: '/contact' },
              ].map(({ label, path }) => (
                <li key={label}>
                  <button
                    onClick={go(path)}
                    className="text-sm transition-colors text-left"
                    style={{ color: '#4c4c4c' }}
                    onMouseEnter={e => (e.currentTarget.style.color = GREEN)}
                    onMouseLeave={e => (e.currentTarget.style.color = '#4c4c4c')}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Stay in Touch ─────────────────────────────── */}
          <div>
            <h4 className="font-semibold text-black mb-5" style={{ fontSize: '18px' }}>
              Stay in Touch
            </h4>
            <div className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter email to Subscribe"
                className="w-full px-4 py-2 rounded-lg border text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2"
                style={{ borderColor: '#bbb', outline: 'none' }}
                onFocus={e => (e.currentTarget.style.boxShadow = `0 0 0 2px ${GREEN}40`)}
                onBlur={e => (e.currentTarget.style.boxShadow = 'none')}
              />
              <button
                onClick={() => { navigate('/contact'); }}
                className="w-full py-2 rounded-lg text-sm font-semibold text-white transition-opacity hover:opacity-90"
                style={{ backgroundColor: GREEN }}
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* ── Bottom bar ───────────────────────────────────── */}
        <div className="border-t mt-10 pt-8 pb-8 flex flex-col md:flex-row justify-between items-center gap-4" style={{ borderColor: '#e3f1dd' }}>
          <p className="text-sm text-gray-500 text-center md:text-left">
            © 2025 Dhoondh. All rights reserved.<br />
            AMPS DHOONDH RECRUITMENT LLP
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            {[
              { label: 'Privacy',  path: '/privacy' },
              { label: 'Terms',    path: '/terms' },
              { label: 'Cookies',  path: '/cookies' },
              { label: 'FAQ',      path: '/faq' },
              { label: 'Refunds',  path: '/cancellation-refunds' },
            ].map(({ label, path }) => (
              <button
                key={label}
                onClick={go(path)}
                className="text-sm text-gray-500 hover:text-black transition-colors"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
